//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { openStockControlDialog } from './StockControl.js'
import { axiosGet } from '../../../../axios/axios.js'

export default {
  name: 'VehicleIssuanceStockControl',
  props: {
    vehicleIssuance: {
      type: Object,
      required: true
    },
    stockControls: {
      type: Array,
      required: true
    },
    stockControl: {
      type: Object,
      required: true
    },
    stage: {
      type: String,
      default: null
    },
    mobile: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
    }
  },
  computed: {
    performed: function () {
      return !!this.stockControl.stockControlRecord && !this.skipped
    },
    skipped: function () {
      return !!this.stockControl.stockControlRecord && !!this.stockControl.stockControlRecord.skipped
    },
    totalCount: function () {
      const tools = this.stockControl.tools
      return tools && tools.length || 0
    },
    presentCount: function () {
      if (this.performed) {
        const tools = this.stockControl.tools
        if (tools && tools.length) {
          return tools.filter(item => item.controlResult && item.controlResult.id === 'present').length
        }
      }
      return 0
    },
    blockStyle: function () {
      if (this.performed) {
        if (this.presentCount < this.totalCount) {
          return 'background-color: #ffbaba;' // red, border: 1px solid green;
        } else {
          return 'background-color: #ceffce;' // green
        }
      } else {
        if (this.stockControl.required) {
          return 'background-color: #fffcce; border: 2px solid #c10015;' // yellow
        } else {
          return 'background-color: #e3f2fd;' // bg-blue-1
        }
      }
    }
  },
  methods: {
    onOpenStockControl: function () {
      openStockControlDialog({
        stockControl: this.stockControl,
        formId: 'vehicleIssuance',
        readonly: this.readonly,
        onRecordSaved: (stockControlRecordId) => {
          this.updateRecord(stockControlRecordId)
        },
        mobile: this.mobile,
        target: this
      })
    },
    updateRecord: function (stockControlRecordId) {
      if (!stockControlRecordId) {
        stockControlRecordId = this.stockControl.stockControlRecord.id
      }

      this.loading = true

      const urlParams = new URLSearchParams()
      urlParams.set('stockControlRecordId', stockControlRecordId)

      return axiosGet({
        url: 'service/delta/stock/control/record/getStockControl?' + urlParams.toString(),
        onSuccess: (response) => {
          const stockControl = response.data.result

          const stockControls = this.stockControls
          const index = stockControls.indexOf(this.stockControl)
          stockControls.splice(index, 1, stockControl)
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message || 'Ошибка получения результатов контроля наличия',
            progress: true,
            timeout: 10000
          })

          return Promise.reject(response.message)
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}

